import { range } from 'ramda';

type HourOfDay =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23;

export type TimeOfDay = `${HourOfDay}:00`;
const _times = range(0, 24).map((x) => `${x}:00` as TimeOfDay);

export const times = () => _times;
